// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bundle_india {
  background-color: rgb(243, 243, 243);
  height: 408px;
}
.bundle_india .banner_txt ::after {
  content: none;
}
.bundle_india .banner_txt {
  font-size: 50px;
  font-weight: 700;
  padding-top: 80px;
}
.bundle_india .bundle_india {
  color: rgb(90, 90, 90);
  line-height: 1.2;
}
.bundle_india h2 {
  font-size: 28px;
  margin-top: 20px;
}
.bundle_india .banner_img img:first-child {
  display: block;
  height: 100%;
  width: auto;
  object-fit: cover;
}

.sbi-banner-img {
  position: absolute;
  top: 50%;
  left: 42%;
  transform: translate(-50%, -40%);
}

@media (max-width: 1024px) {
  .bundle_india {
    height: 290px;
  }

  .banner_img img {
    width: 100% !important;
  }

  .bundle_india .banner_txt {
    font-size: 35px;
    text-align: center;
    margin-top: 20px;
  }

  .sbi-banner-img {
    position: static;
    position: initial;
    transform: none;
    transform: initial;
  }

  .bundle_india .banner_txt {
    padding-top: 0;
    padding-top: initial;
  }
}

@media screen and (max-width: 576px) {
  .bundle_india {
    height: auto;
  }
  .bundle_india .banner_img img:first-child {
    width: 100%;
  }
  .bundle_india .banner_txt {
    font-size: 22px !important;
  }
  .bundle_india h2 {
    font-size: 14px;
    text-align: center;
    margin-top: 10px;
  }
  .school_bundle_tabs.tab-list {
    column-gap: 10px;
    padding: 0px 10px;
  }
  .school_bundle_tabs.tab-list {
    font-size: 16px;
  }
  .school_bundle_tabs.tab-list li {
    font-size: 16px;
  }
  .school_bundle_tabs.tab-list li::after {
    font-size: 70px;
    padding-right: 0px;
  }
}

@media only screen and (min-width: 1080px) and (max-width: 1200px) {
  .sbi-banner-img {
    left: 24%;
    transform: translate(-50%, -47%);
  }

  .bundle_india .banner_txt {
    padding-top: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/bundle/Banner.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAe;IAAf,iBAAe;IACf,eAAgB;IAAhB,kBAAgB;EAClB;;EAEA;IACE,cAAkB;IAAlB,oBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".bundle_india {\n  background-color: rgb(243, 243, 243);\n  height: 408px;\n}\n.bundle_india .banner_txt ::after {\n  content: none;\n}\n.bundle_india .banner_txt {\n  font-size: 50px;\n  font-weight: 700;\n  padding-top: 80px;\n}\n.bundle_india .bundle_india {\n  color: rgb(90, 90, 90);\n  line-height: 1.2;\n}\n.bundle_india h2 {\n  font-size: 28px;\n  margin-top: 20px;\n}\n.bundle_india .banner_img img:first-child {\n  display: block;\n  height: 100%;\n  width: auto;\n  object-fit: cover;\n}\n\n.sbi-banner-img {\n  position: absolute;\n  top: 50%;\n  left: 42%;\n  transform: translate(-50%, -40%);\n}\n\n@media (max-width: 1024px) {\n  .bundle_india {\n    height: 290px;\n  }\n\n  .banner_img img {\n    width: 100% !important;\n  }\n\n  .bundle_india .banner_txt {\n    font-size: 35px;\n    text-align: center;\n    margin-top: 20px;\n  }\n\n  .sbi-banner-img {\n    position: unset;\n    transform: unset;\n  }\n\n  .bundle_india .banner_txt {\n    padding-top: unset;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .bundle_india {\n    height: auto;\n  }\n  .bundle_india .banner_img img:first-child {\n    width: 100%;\n  }\n  .bundle_india .banner_txt {\n    font-size: 22px !important;\n  }\n  .bundle_india h2 {\n    font-size: 14px;\n    text-align: center;\n    margin-top: 10px;\n  }\n  .school_bundle_tabs.tab-list {\n    column-gap: 10px;\n    padding: 0px 10px;\n  }\n  .school_bundle_tabs.tab-list {\n    font-size: 16px;\n  }\n  .school_bundle_tabs.tab-list li {\n    font-size: 16px;\n  }\n  .school_bundle_tabs.tab-list li::after {\n    font-size: 70px;\n    padding-right: 0px;\n  }\n}\n\n@media only screen and (min-width: 1080px) and (max-width: 1200px) {\n  .sbi-banner-img {\n    left: 24%;\n    transform: translate(-50%, -47%);\n  }\n\n  .bundle_india .banner_txt {\n    padding-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
